/**
 * Feedback service request model.
 *
 * @param {Object} state Data model object
 * @param {string} state.type
 * @param {string} state.description
 * @param {boolean} state.canBeContacted
 * @param {boolean} state.enrollInResearchGroup
 */

const request = state => ({
  Type: state.type,
  Description: state.description,
  CanBeContacted: state.canBeContacted,
  EnrollInResearchGroup: state.enrollInResearchGroup,
});

export default request;
